<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {};
  },
  created() {
    console.log(process.env, "process.env");
  },
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 0;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.25);
  transition: color 0.2s ease;
}
#app {
  font-family: "PingFang SC", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  background: #fafafa;
  cursor: pointer;
}
</style>
<style lang="scss">
.addModules_wrap_content {
  .tox .tox-statusbar {
    display: none !important;
  }
  .tox-tinymce {
    height: 550px !important;
  }
}

//设置鼠标悬停显示为小手
.el-dialog {
  cursor: pointer;
}

.el-form-item__label {
  cursor: pointer;
}

// .el-input__inner:hover {
//     cursor: pointer;
// }

</style>


// WEBPACK FOOTER //
// src/App.vue